<template>
  <Header />
  <div class="title-container">
    <h1>Trainees</h1>
  </div>
  <div class="container-fluid-trainee">
    <vue-good-table :columns="columns" :rows="processedRows" :pagination-options="{
      enabled: true,
      perPage: perPage
    }" :search-options="{ enabled: false }" :sort-options="{ enabled: true }">
      <template #table-row="props">
        <!-- Logbooks -->
        <span v-if="props.column.field === 'logbooks'">
          <span v-if="props.row.logbooks.length">
            <span
              v-for="(lb, index) in props.row.logbooks"
              :key="lb.id"
              :title="lb.name"
            >
              {{ lb.id }}<span v-if="index < props.row.logbooks.length - 1">, </span>
            </span>
          </span>
          <span v-else>None</span>
        </span>
        <!-- Projects -->
        <span v-else-if="props.column.field === 'projects'">
          <span v-if="props.row.projects.length">
            <span
              v-for="(project, index) in props.row.projects"
              :key="project.id"
              :title="project.name"
            >
              {{ project.id }}<span v-if="index < props.row.projects.length - 1">, </span>
            </span>
          </span>
          <span v-else>None</span>
        </span>
        <!-- Actions -->
        <span v-else-if="props.column.field === 'actions'" class="center-icons">
          <font-awesome-icon icon="edit" class="edit-icon" title="Edit" @click="openEditTrainee(props.row.user_id)" />
          <font-awesome-icon icon="trash-alt" class="delete-icon" title="Delete"
            @click="deleteTrainee(props.row.user_id)" />
        </span>
        <!-- Default cell -->
        <span v-else :title="String(props.formattedRow[props.column.field] ?? '')">
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
  </div>
  <div>
    <button class="btn btn-primary rounded" id=addlogbookButton @click="openAddTrainee()">Add Trainee</button>
    <button class="btn btn-primary rounded" id=importTraineeButton @click="goToImportTrainee">Import Trainees</button>
  </div>
  <edit-trainee-modal v-if="showEditTrainee" :users="users" :user="selectedTrainee" @close="closeEditTrainee"></edit-trainee-modal>
  <add-trainee-modal v-if="showAddTraineeModal" :selectedSessionId="selectedSessionId"
    @close="closeAddTrainee"></add-trainee-modal>
</template>

<script>
import Header from '../Header.vue';
import axios from 'axios';
import { VueGoodTable } from 'vue-good-table-next';
import 'vue-good-table-next/dist/vue-good-table-next.css';
import EditTraineeModal from './EditTraineeModal.vue';
import AddTraineeModal from './AddTraineeModal.vue';

export default {
  name: 'ViewTraineeTable',
  components: {
    Header,
    VueGoodTable,
    EditTraineeModal,
    AddTraineeModal,
  },

  data() {
    return {
      users: [],
      trainees: [],
      projects: [],
      logbooks: [],
      trainee_projects: [],
      perPage: 10,
      showAddTraineeModal: false,
      showEditTrainee: false,
      selectedTrainee: null,
    };
  },
  computed: {
    columns() {
      return [
      {
          label: 'ID',
          field: 'user_id',
          sortable: true,
          thClass: 'vgt-id-column',
          tdClass: 'vgt-id-column',
          filterOptions: {
            enabled: true,
            placeholder: 'All',
            filterFn: (rowValue, filterValue) => {
              if (!filterValue) return true;
              return String(rowValue || '')
                .toLowerCase()
                .includes(String(filterValue).toLowerCase());
            },
          },
        },
        {
          label: 'First Name',
          field: 'first_name',
          sortable: true,
          thClass: 'vgt-first-name-column',
          tdClass: 'vgt-first-name-column',
          filterOptions: {
            enabled: true,
            placeholder: 'All',
            filterFn: (rowValue, filterValue) => {
              if (!filterValue) return true;
              return String(rowValue || '')
                .toLowerCase()
                .includes(String(filterValue).toLowerCase());
            },
          },
        },
        {
          label: 'Last Name',
          field: 'last_name',
          sortable: true,
          thClass: 'vgt-last-name-column',
          tdClass: 'vgt-last-name-column',
          filterOptions: {
            enabled: true,
            placeholder: 'All',
            filterFn: (rowValue, filterValue) => {
              if (!filterValue) return true;
              return String(rowValue || '')
                .toLowerCase()
                .includes(String(filterValue).toLowerCase());
            },
          },
        },
        {
          label: 'Email',
          field: 'email',
          sortable: true,
          thClass: 'vgt-email-column',
          tdClass: 'vgt-email-column',
          filterOptions: {
            enabled: true,
            placeholder: 'All',
            filterFn: (rowValue, filterValue) => {
              if (!filterValue) return true;
              return String(rowValue || '')
                .toLowerCase()
                .includes(String(filterValue).toLowerCase());
            },
          },
        },
        {
          label: 'License No',
          field: 'license_no',
          sortable: true,
          thClass: 'vgt-uid-column',
          tdClass: 'vgt-uid-column',
          filterOptions: {
            enabled: true,
            placeholder: 'All',
            filterFn: (rowValue, filterValue) => {
              if (!filterValue) return true;
              return String(rowValue || '')
                .toLowerCase()
                .includes(String(filterValue).toLowerCase());
            },
          },
        },
        {
          label: `${this.$labels.project}s`,
          field: 'projects',
          sortable: false,
          thClass: 'vgt-multi-id-column',
          tdClass: 'vgt-multi-id-column',
          filterOptions: {
            enabled: true,
            placeholder: 'All',
            filterDropdownItems: this.uniqueProjectOptions,
            filterFn: (rowValue, filterValue) => {
              if (!filterValue) return true;
              return Array.isArray(rowValue) &&
                rowValue.some(p => String(p.id) === String(filterValue));
            },
          },
        },
        {
          label: `Logbooks`,
          field: 'logbooks',
          sortable: false,
          thClass: 'vgt-multi-id-column',
          tdClass: 'vgt-multi-id-column',
          filterOptions: {
            enabled: true,
            placeholder: 'All',
            filterDropdownItems: this.uniqueLogbookOptions,
            filterFn: (rowValue, filterValue) => {
              if (!filterValue) return true;
              return Array.isArray(rowValue) &&
                rowValue.some(p => String(p.id) === String(filterValue));
            },
          },
        },
        { label: 'Actions', field: 'actions', sortable: false, thClass: 'vgt-actions-column', tdClass: 'vgt-actions-column' }
      ];
    },
    uniqueProjectOptions() {
      const usedProjectIds = [
        ...new Set(
          this.trainees
            .flatMap(t => (Array.isArray(t.projects) ? t.projects.map(p => p.id) : []))
            .filter(Boolean)
        ),
      ];

      return usedProjectIds.map(id => {
        const project = this.projects.find(p => String(p.project_id) === String(id));
        return {
          value: String(id),
          text: project ? `${project.project_id} - ${project.name}` : `Project ${id}`,
        };
      });
    },
    uniqueLogbookOptions() {
      const usedLogbookIds = [
        ...new Set(
          this.trainees
            .flatMap(t => Array.isArray(t.logbooks) ? t.logbooks.map(lb => lb.id) : [])
            .filter(Boolean)
        ),
      ];

      return usedLogbookIds.map(id => {
        const logbook = this.logbooks.find(lb => String(lb.logbook_id) === String(id));

        return {
          value: String(id),
          text: logbook ? `${logbook.logbook_id} - ${logbook.name}` : `Logbook ${id}`,
        };
      });
    },
    processedRows() {
      return this.trainees.map(t => ({
        ...t,

        project_ids_display: Array.isArray(t.projects) && t.projects.length
          ? t.projects.map(p => p.id).join(', ')
          : '',
        project_names_display: Array.isArray(t.projects) && t.projects.length
          ? t.projects.map(p => `${p.id} - ${p.name}`).join(' | ')
          : 'None',

        logbook_ids_display: Array.isArray(t.logbooks) && t.logbooks.length
          ? t.logbooks.map(lb => lb.id).join(', ')
          : '',
        logbook_names_display: Array.isArray(t.logbooks) && t.logbooks.length
          ? t.logbooks.map(lb => `${lb.id} - ${lb.name}`).join(' | ')
          : 'None',
      }));
    },
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        // Fetch all trainees
        let result = await axios.get('/api/users', { headers });
        this.users = result.data;
        let userProjectResult = await axios.get('/api/user/projects', { headers });
        this.trainee_projects = userProjectResult.data.user_projects;

        let projectResult = await axios.get('/api/projects', { headers });
        this.projects = projectResult.data;

        // Fetch all logbooks
        let result_logbooks = await axios.get('/api/logbooks', { headers });
        this.logbooks = result_logbooks.data;

        if (result.status === 200) {
          this.trainees = result.data.filter(user => Array.isArray(user.roles) && user.roles.includes('trainee'));

          for (let i = 0; i < this.trainees.length; i++) {
            const userId = this.trainees[i].user_id;
            // Find the logbooks for the current user by matching the user_id
            const userLogbooks = result_logbooks.data.filter(logbook => logbook.trainee_id === userId);
            this.trainees[i].logbooks = userLogbooks.map(logbook => ({
              id: logbook.logbook_id,
              name: logbook.name,
            }));

            const userProjects = this.trainee_projects
              .filter(proj => proj.user_id === userId && proj.role === 'trainee');

            // Get both project IDs and names
            this.trainees[i].projects = userProjects.map(proj => {
              const matchedProject = this.projects.find(p => p.project_id === proj.project_id);
              return {
                id: proj.project_id,
                name: matchedProject ? matchedProject.name : 'Unknown',
              };
            });
          }
        }

      } catch (error) {
        console.error('An error occurred while fetching data:', error);
      }
    },
    deleteTrainee(user_id) {
      if (confirm("Are you sure you want to delete this trainee?")) {
        if (confirm("This action will PERMANENTLY delete the user from the database. Do you wish to continue?")) {
          // If the user confirms the deletion, send a request to delete the trainee.
          const token = localStorage.getItem('token');
          const headers = { Authorization: `Bearer ${token}` };

          axios
            .delete(`/api/users/${user_id}`, { headers })
            .then(response => {
              if (response.status === 200) {
                // Remove the deleted trainee from the local data
                this.trainees = this.trainees.filter(trainee => trainee.user_id !== user_id);

                window.alert('User deleted Successfully');
              }
            })
            .catch(error => {
              if (error.isOffline === true) {
                this.$emit('close');
                return;
              }
              if (error.response && error.response.status === 500) {
                const errorMessage = error.response.data.message;
                const isForeignKeyConstraintError = errorMessage.includes('SQLSTATE[23000]') && errorMessage.includes('Integrity constraint violation: 1451');

                if (isForeignKeyConstraintError) {
                  window.alert('This Trainee cannot be deleted because they have one or more Logbooks.');
                } else {
                  window.alert('An error occurred while deleting the Trainee. Please try again.');
                }
              } else {
                console.error('An unexpected error occurred:', error);
                window.alert('An unexpected error occurred. Please try again.');
              }
            });
        }
      }
    },
    goToImportTrainee() {
      this.$router.push({ name: 'ImportTrainees' });
    },
    openEditTrainee(user_id) {
      localStorage.setItem('user_id', user_id);
      this.selectedTrainee = this.trainees.find(c => c.user_id === user_id);
      this.showEditTrainee = true; // Show the modal when the button is clicked
    },
    closeEditTrainee() {
      this.showEditTrainee = false; // Close the modal
    },
    openAddTrainee() {
      this.showAddTraineeModal = true; // Show the modal when the button is clicked
    },
    closeAddTrainee() {
      this.showAddTraineeModal = false; // Close the modal
      this.fetchData();
    },
  }
};
</script>


<style scoped>
.container-fluid-trainee {
  padding-top: 10px;
  width: 97%;
  margin-left: 1.5%;
  margin-right: 1.5%;
  display: flex;
  justify-content: center;
}

button.btn#addlogbookButton {
  padding: 10px 10px;
  font-size: 16px;
  width: 180px;
  height: 40px;
  margin-top: 0px;
  margin-bottom: 15px;
  margin-right: 20px;
  border: 1px solid rgb(0, 96, 134);
  background: #2952c4;
  color: white;
  cursor: pointer;
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
  float: right;
}

button.btn#addlogbookButton:hover {
  background-color: #0c1a61;
  transition: transform 0.2s, box-shadow 0.2s;
}

button.btn#importTraineeButton {
  padding: 10px 10px;
  font-size: 16px;
  width: 180px;
  height: 40px;
  margin-top: 0px;
  margin-bottom: 15px;
  margin-right: 20px;
  border: 1px solid rgb(17, 80, 20);
  background: #2c752c;
  color: white;
  cursor: pointer;
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
  float: right;
}

button.btn#importTraineeButton:hover {
  background-color: #184218;
  transition: transform 0.2s, box-shadow 0.2s;
}

h1 {
  padding-top: 0px;
  padding-left: 3%;
}

label {
  margin-top: 8px;
}

.edit-icon {
  font-size: 16px;
  /* Adjust the size as needed */
  color: #615f5f;
  /* Change the color to your preference */
  cursor: pointer;
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
}

.edit-icon:hover {
  color: #2b2a2a;
  /* Change the color to your preference */
  cursor: pointer;
  transform: scale(1.1);
  /* Example transform for scaling on hover */

}

.delete-icon {
  font-size: 16px;
  color: #FF0000;
  /* Red color */
  cursor: pointer;
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
  padding-left: 15px;
}

.delete-icon:hover {
  color: #a82222;
  /* Lighter red color on hover */
  cursor: pointer;
  transform: scale(1.1);
  /* Scale the icon on hover */
  /* You can also add a box-shadow or any other styles you prefer */
}

input {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  width: 200px;
}

select {
  padding: 5px;
  border-radius: 5px;
  font-size: 16px;
  width: 200px;
}
</style>